"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceInitProps = exports.CommonProps = exports.FilterableRing = exports.Ring = exports.AssetTag = exports.ProtocolVersion = exports.ConnectionStatus = exports.ContactInfo = exports.Dealer = exports.NullableDetectedLocation = exports.DetectedLocation = exports.State = exports.Connectivity = exports.CONNECTIVITY_ALIAS_MAP = exports.Msn = exports.InstallationStatus = exports.LogLevel = exports.PowerProfile = exports.OperatingMode = exports.shouldIgnoreConnect = exports.shouldIgnoreDisconnect = exports.ConnectionGateway = exports.ConnectionState = exports.LocationTechnology = exports.NAMESPACE = void 0;
exports.makeConnectivity = makeConnectivity;
const effect_1 = require("effect");
const azure_1 = require("../../../azure");
const entity_1 = require("../../../entity");
const geography_1 = require("../../../geography");
const Json = __importStar(require("../../../json"));
const schema_1 = require("../../../schema");
const base_1 = require("../../business-unit/base");
const tenant_1 = require("../../tenant");
const user_1 = require("../../user");
const loyalty_1 = require("../../user/loyalty");
const _util_1 = require("./_util");
const common_1 = require("./common");
exports.NAMESPACE = 'Culligan.Device.Class.Base';
exports.LocationTechnology = effect_1.Schema.Enums({
    Cellular: 'CELL',
    Injected: 'INJECTED',
    Override: 'OVERRIDE',
}).annotations({ identifier: `${exports.NAMESPACE}.LocationTechnology` });
exports.ConnectionState = effect_1.Schema.Union(effect_1.Schema.Literal('connected'), effect_1.Schema.Literal('disconnected')).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionState`,
    description: 'Device connection state: connected (online) or disconnected (offline). Used for filtering and aggregations.',
});
exports.ConnectionGateway = effect_1.Schema.Literal('AzureIotHub', 'TartabitBridge').annotations({
    identifier: `${exports.NAMESPACE}.ConnectionGateway`,
    description: 'How a device reaches IoT Hub. Bridged gateways relay events from their own session, not the device, so connect/disconnect events are ignored.',
});
/**
 * Whether `deviceDisconnected` events from IoT Hub should be ignored for a
 * device using the given gateway. Bridged gateways multiplex many devices over
 * a single relay session, so a `deviceDisconnected` may reflect the relay's
 * state — not the physical device.
 */
const shouldIgnoreDisconnect = (gateway) => gateway === 'TartabitBridge';
exports.shouldIgnoreDisconnect = shouldIgnoreDisconnect;
/**
 * Whether `deviceConnected` events from IoT Hub should be ignored for a
 * device using the given gateway. Bridged gateways can emit ghost connect
 * events (e.g. after a relay restart) that do not correspond to the physical
 * device coming online — telemetry remains the authoritative signal.
 */
const shouldIgnoreConnect = (gateway) => gateway === 'TartabitBridge';
exports.shouldIgnoreConnect = shouldIgnoreConnect;
exports.OperatingMode = effect_1.Schema.Literal('Disabled', 'Factory', 'Fault', 'Installation', 'Ota', 'Standard', 'Startup', 'Service').annotations({
    identifier: `${exports.NAMESPACE}.OperatingMode`,
});
exports.PowerProfile = effect_1.Schema.Literal('Standard', 'Eco', 'Sleep').annotations({
    identifier: `${exports.NAMESPACE}.PowerProfile`,
});
exports.LogLevel = effect_1.Schema.Literal('Debug', 'Silent', 'Warning', 'Trace').annotations({
    identifier: `${exports.NAMESPACE}.LogLevel`,
});
exports.InstallationStatus = effect_1.Schema.Literal('Customer', 'Warehouse', 'Factory').annotations({
    identifier: `${exports.NAMESPACE}.InstallationStatus`,
});
exports.Msn = schema_1.PrintString.annotations({
    identifier: `${exports.NAMESPACE}.Msn`,
    description: 'The serial number assigned by the manufacturer',
});
/**
 * @internal Use {@link Connectivity} or {@link makeConnectivity} instead.
 */
exports.CONNECTIVITY_ALIAS_MAP = {
    'Cellular': (0, schema_1.makeAlias)('Cellular', [
        'CELLULAR',
        '2G',
        '4G',
        '5G',
        'LTE cat 1-4',
        'LTE cat M1',
        'NB-IoT',
        'Nb-IoT 2',
    ]).annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.Cellular`,
    }),
    'CellularVPN': effect_1.Schema.Literal('CellularVPN').annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.CellularVPN`,
    }),
    'Wi-Fi': (0, schema_1.makeAlias)('Wi-Fi', ['WI-FI']).annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.Wi-Fi`,
    }),
    'Ethernet': (0, schema_1.makeAlias)('Ethernet', ['ETHERNET']).annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.Ethernet`,
    }),
    'Off': (0, schema_1.makeAlias)('Off', ['N/A']).annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.Off`,
    }),
    'BLE': effect_1.Schema.Literal('BLE').annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.BLE`,
    }),
    'Sidewalk': effect_1.Schema.Literal('Sidewalk').annotations({
        identifier: `${exports.NAMESPACE}.CONNECTIVITY_ALIAS_MAP.Sidewalk`,
    }),
};
exports.CONNECTIVITY_ALIAS_MAP;
exports.Connectivity = effect_1.Schema.Union(...effect_1.Record.values(exports.CONNECTIVITY_ALIAS_MAP)).annotations({
    identifier: `${exports.NAMESPACE}.Connectivity`,
});
/**
 * Utility function for creating a narrowed {@link Connectivity} schema that
 * permits legacy encodings on the encoded side of the schema.
 *
 * Automatically annotates the returned schema with an `identifier` annotation
 * equal to the passed `namespace` suffixed with `.Connectivity`.
 */
function makeConnectivity(namespace, connectivities) {
    return effect_1.Schema.Union(...connectivities.map(connectivity => exports.CONNECTIVITY_ALIAS_MAP[connectivity])).annotations({ identifier: `${namespace}.Connectivity` });
}
exports.State = effect_1.Schema.Struct({
    operatingMode: exports.OperatingMode,
    powerProfile: exports.PowerProfile,
    logLevel: exports.LogLevel,
    connectivity: effect_1.Schema.optionalWith(exports.Connectivity, { exact: true }),
    msn: effect_1.Schema.optionalWith(exports.Msn, { nullable: true, exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.DetectedLocation = effect_1.Schema.Struct({
    ...geography_1.GeoPosition.fields,
    tech: exports.LocationTechnology,
    accuracy: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DetectedLocation`,
    description: 'Detected location of the device',
});
exports.NullableDetectedLocation = effect_1.Schema.Union(effect_1.Schema.Null, geography_1.NullFromEmptyGeoPosition, exports.DetectedLocation).annotations({
    identifier: `${exports.NAMESPACE}.NullableDetectedLocation`,
    description: 'Detected location that can be null and is null if the geo position is empty',
});
exports.Dealer = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The ID of the dealer who installed the device',
    }),
    accountNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'The account number of the device in the dealer CRM',
    }),
}).annotations({ identifier: `${exports.NAMESPACE}.Dealer` });
exports.ContactInfo = effect_1.Schema.Struct({
    phoneNumber: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The phone number of the contact',
    }),
    email: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The email of the contact',
    }),
    name: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The name of the contact',
    }),
    customerAccountId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }).annotations({
        description: 'The customer account id of the contact',
    }),
}).annotations({ identifier: `${exports.NAMESPACE}.ContactInfo` });
exports.ConnectionStatus = effect_1.Schema.Struct({
    online: effect_1.Schema.Boolean,
    lastUpdate: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last connection status update',
    }),
    checkAfter: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber), {
        default: () => null,
        exact: true,
    }).annotations({
        description: 'The timestamp of the expiration of the current connection status (ping the device after this time)',
    }),
    hub: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString)).annotations({
        description: 'The name of the last known IoT Hub where the device is connected, in case the device connects through DPS',
    }),
}).annotations({ identifier: `${exports.NAMESPACE}.ConnectionStatus` });
exports.ProtocolVersion = effect_1.Schema.Literal(2, 3).annotations({
    identifier: `${exports.NAMESPACE}.ProtocolVersion`,
});
exports.AssetTag = schema_1.PrintString.pipe(effect_1.Schema.maxLength(100)).annotations({
    identifier: `${exports.NAMESPACE}.AssetTag`,
});
exports.Ring = effect_1.Schema.Literal('canary', 'stable').annotations({
    identifier: `${exports.NAMESPACE}.Ring`,
});
exports.FilterableRing = exports.Ring.pipe(effect_1.Schema.pickLiteral('canary')).annotations({
    identifier: `${exports.NAMESPACE}.FilterableRing`,
});
exports.CommonProps = effect_1.Schema.Struct({
    ...entity_1.BaseTimestampedEntity.fields,
    id: common_1.Id,
    hwVersion: effect_1.Schema.NullOr(effect_1.Schema.String),
    swVersion: effect_1.Schema.NullOr(effect_1.Schema.String),
    protocolVersion: exports.ProtocolVersion,
    connectionStatus: exports.ConnectionStatus,
    installationStatus: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.InstallationStatus), {
        exact: true,
        default: effect_1.Function.constNull,
    }),
    dealer: exports.Dealer,
    businessUnit: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(base_1.BusinessUnit), {
        exact: true,
        default: effect_1.Function.constNull,
    }),
    assetTag: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(exports.AssetTag), {
        default: effect_1.Function.constNull,
        exact: true,
    }),
    manufacturingSerialNumber: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(schema_1.PrintString)).annotations({
        description: 'The expected device MSN; actual device-reported MSN is in state.msn',
    }),
    errors: effect_1.Schema.propertySignature(Json.Array).annotations({
        description: 'A list errors that are currently active on the device',
    }),
    installationAddress: geography_1.Address,
    detectedLocation: effect_1.Schema.propertySignature(exports.NullableDetectedLocation).annotations({
        description: 'The location that the device detected for itself, or derived from its address',
    }),
    providedLocation: effect_1.Schema.propertySignature(effect_1.Schema.Union(effect_1.Schema.Null, geography_1.NullFromEmptyGeoPosition, geography_1.NonEmptyGeoPosition)).annotations({
        description: 'The location that was provided by the user or installer of the unit',
    }),
    ownerId: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(user_1.Id)).annotations({
        description: 'The ID of the user who owns the device',
    }),
    contactInfo: effect_1.Schema.propertySignature(exports.ContactInfo).annotations({
        description: 'The contacts of the person or company responsible for this unit',
    }),
    installedAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber), {
        exact: true,
        default: effect_1.Function.constNull,
    }).annotations({
        description: 'The date and time of the device installation',
    }),
    installationUpdatedAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber), {
        exact: true,
        default: effect_1.Function.constNull,
    }).annotations({
        description: 'The date and time of the last installation status update',
    }),
    registeredAt: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The date and time of the device registration to a user',
    }),
    deregisteredAt: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The date and time of the device deregistration from a user',
    }),
    lastStateUpdate: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last state update',
    }),
    lastTelemetryUpdate: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last telemetry update',
    }),
    lastConsumablesUpdate: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last consumables update',
    }),
    lastConfigUpdate: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last configuration update',
    }),
    lastEventTime: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last event',
    }),
    lastAlarmTime: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last alarm',
    }),
    lastErrorTime: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.DateFromNumber)).annotations({
        description: 'The timestamp of the last error',
    }),
    loyaltyPrograms: effect_1.Schema.propertySignature(effect_1.Schema.Array(loyalty_1.LoyaltyProgramId)).annotations({
        description: 'The list of loyalty programs that the device is enrolled in',
    }),
    region: effect_1.Schema.propertySignature(azure_1.MacroRegion).annotations({
        description: 'The region where the device is connected',
    }),
    dataRegions: effect_1.Schema.propertySignature(azure_1.DataRegions).annotations({
        description: 'The list of physical Cloud regions where the device was connected and its data is stored',
    }),
    tenantId: tenant_1.Id.pipe(effect_1.Schema.optionalWith({ nullable: true, exact: true, default: () => tenant_1.ROOT_TENANT_ID })),
    ring: effect_1.Schema.optionalWith(effect_1.Schema.String, { nullable: true, exact: true }).annotations({
        description: 'Progressive-delivery ring assignment (see Ring). Loose string on read; absent/null means the default (stable) ring',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CommonProps`,
});
/**
 * Common device initialization function to eliminate duplication across device classes
 *
 * @internal
 */
const deviceInitProps = (defaultState, slots, sku, props, time) => ({
    alarms: [],
    connectionStatus: props.connectionStatus,
    installationStatus: 'Factory',
    consumables: (0, _util_1.makeEmptySlots)(slots),
    contactInfo: {
        email: null,
        name: null,
        phoneNumber: null,
        customerAccountId: null,
    },
    createdAt: typeof time === 'object' && 'createdAt' in time ? time.createdAt : time,
    dataRegions: props.dataRegions,
    dealer: {
        id: null,
    },
    deregisteredAt: null,
    detectedLocation: null,
    errors: [],
    hwVersion: null,
    id: props.id,
    installationAddress: {
        address: null,
        addressExtra: null,
        zip: null,
        city: null,
        state: null,
        country: null,
        countryCode: null,
    },
    lastAlarmTime: null,
    lastConfigUpdate: null,
    lastConsumablesUpdate: null,
    lastErrorTime: null,
    lastEventTime: null,
    lastStateUpdate: null,
    lastTelemetryUpdate: null,
    latestTelemetry: {},
    loyaltyPrograms: [],
    manufacturingSerialNumber: null,
    assetTag: null,
    ownerId: null,
    protocolVersion: props.protocolVersion,
    providedLocation: null,
    region: props.region,
    registeredAt: typeof time === 'object' && 'registeredAt' in time ? time.registeredAt : time,
    state: {
        ...defaultState,
        sku,
    },
    swVersion: null,
    updatedAt: typeof time === 'object' && 'updatedAt' in time ? time.updatedAt : time,
    vendor: props.vendor,
});
exports.deviceInitProps = deviceInitProps;
//# sourceMappingURL=base.js.map